<template>
  <div class="button-list">
    <div v-for="(button, index) in buttons" :key="index" class="btn-list-item">
      <v-btn
        large
        round
        block
        color="primary"
        @click="selectButton(index)"
        class="btn-border"
        :outline="index === selectedButtonIndex ? false : true"
      >
        {{ button.title ? button.title : "Unnamed Button" }}
      </v-btn>
      <v-btn
        class="delete-button"
        @click="deleteButton(index)"
        fab
        small
        color=""
      >
        <v-icon small color="error">delete_outline</v-icon>
      </v-btn>
    </div>

    <v-btn
      v-if="!showOnly"
      large
      round
      flat
      block
      class="primary--text"
      :disabled="buttons.length >= limit"
      @click="addButton"
    >
      <v-icon>add_circle_outline</v-icon>
      Add Button
    </v-btn>
    <div class="selected-button" v-if="buttons.length && !showOnly">
      <v-form ref="form" v-model="valid">
        <label>Button Title</label>
        <vTextareaAutocomplete
          v-model="buttons[selectedButtonIndex].title"
          :type="'textfield'"
          :counter="20"
          :validationRules="autocompleteButtonValidationRules"
        ></vTextareaAutocomplete>

        <label>Button Description</label>
        <vTextareaAutocomplete
          v-model="buttons[selectedButtonIndex].description"
          :type="'textfield'"
          :counter="72"
          :validationRules="autocompleteButtonValidationRules"
        ></vTextareaAutocomplete>

        <label>Button Alternatives</label>
        <v-combobox
          v-model="buttons[selectedButtonIndex].alternatives"
          :items="[]"
          chips
          outline
          solo
          multiple
          class=""
        >
          <template v-slot:selection="data">
            <v-chip
              :selected="data.selected"
              class="rule-chip"
              close
              @input="removeItem(data.item)"
            >
              <strong>{{ data.item }}</strong
              >&nbsp;
            </v-chip>
          </template>
        </v-combobox>

        <label for="">Button Action</label>
        <v-tabs
          centered
          grow
          color="#F4F5F9"
          v-model="activeTab"
          @change="changeTab"
        >
          <v-tab>
            <v-icon small class="mr-2">dashboard</v-icon>
            Block
          </v-tab>
          <v-tab>
            <v-icon class="mr-2">link</v-icon>
            URL
          </v-tab>
          <v-tab>
            <v-icon small class="mr-2">phone</v-icon>
            Phone
          </v-tab>
          <v-tab>
            <v-icon small class="mr-2">mdi-arrange-send-backward</v-icon>
            Event
          </v-tab>
          <v-tab-item class="mt-3">
            <label>Enter Block</label>
            <v-autocomplete
              v-if="activeTab === 0"
              :items="blocksList"
              item-text="name"
              item-value="id"
              v-model="buttons[selectedButtonIndex].block_id"
              :rules="[(v) => !!v || 'Block is Required']"
              outline
              solo
            >
            </v-autocomplete>
          </v-tab-item>
          <v-tab-item class="mt-3">
            <label>Button URL</label>
            <v-text-field
              v-if="activeTab === 1"
              outline
              v-model="buttons[selectedButtonIndex].url"
              :rules="[(v) => !!v || 'URL is Required']"
            >
            </v-text-field>
          </v-tab-item>
          <v-tab-item class="mt-3">
            <label>Phone</label>
            <v-text-field
              v-if="activeTab === 2"
              outline
              v-model="buttons[selectedButtonIndex].phone"
              :rules="[(v) => !!v || 'Phone is Required']"
            >
            </v-text-field>
          </v-tab-item>
          <v-tab-item class="mt-3">
            <label>Event Name</label>
            <v-text-field
              v-if="activeTab === 3"
              outline
              v-model="buttons[selectedButtonIndex].event"
              :rules="[(v) => !!v || 'Event is Required']"
            >
            </v-text-field>
          </v-tab-item>
        </v-tabs>
      </v-form>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import common from "../../../../../utils/common";

export default {
  name: "button-list",
  props: {
    buttons: {
      type: Array,
      default: () => {
        return [];
      },
    },
    blocksList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showOnly: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 30,
    },
  },
  data() {
    return {
      selectedButton: {
        block_id: "",
        errorOrEmpty: "",
        phone: "",
        title: "",
        type: "",
        url: "",
        event: "",
      },
      buttonsListInputsPreset: 1,
      errorsCount: 0,
      selectedButtonIndex: 0,
      activeTab: 0,
      valid: true,
      common,
      types: [
        {
          position: 0,
          name: "block",
        },
        {
          position: 1,
          name: "url",
        },
        {
          position: 2,
          name: "phone",
        },
        {
          position: 3,
          name: "event",
        },
      ],
      autocompleteButtonValidationRules: [
        (v) => !!v || "Button Title is Required",
        (v) =>
          v.length < 20 || "Button title should be less than 20 characters",
      ],
      autocompleteUrlValidationRules: [
        (v) => !!v || "URL is Required",
        // v => common.validURL(v) || 'URl is not valid'
      ],
      autocompletePhoneValidationRules: [
        (v) => !!v || "Phone is Required",
        // v => v.length > 4 || 'Phone should be at least 4 numbers',
        // v => v.length < 15 || 'Phone should be at max 15 numbers'
      ],
    };
  },
  mounted() {
    this.getActiveTab();

    if (this.buttons.length) {
      this.buttons[this.selectedButtonIndex].block_id = parseInt(
        this.buttons[this.selectedButtonIndex].block_id,
      );
      this.$refs.form.validate();
    }
  },
  methods: {
    selectButton(index) {
      this.selectedButtonIndex = index;
    },
    addButton() {
      const newButton = {
        block_id: "",
        errorOrEmpty: "",
        phone: "",
        title: `Untitled Button`,
        type: "block",
        url: "",
        event: "",
      };
      this.buttons.push(newButton);
      this.selectedButtonIndex = this.buttons.length - 1;
      this.activeTab = 0;
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },
    deleteButton(index) {
      if (this.selectedButtonIndex === index) {
        this.selectedButtonIndex = 0;
      }
      this.buttons.splice(index, 1);
      this.activeTab = 0;
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },
    getActiveTab() {
      if (this.buttons.length) {
        let index = _.findIndex(this.types, (o) => {
          return o.name === this.buttons[this.selectedButtonIndex].type;
        });
        if (index !== -1) {
          this.activeTab = this.types[index].position;
        }
      }
    },
    changeTab() {
      let index = _.findIndex(this.types, (o) => {
        return this.activeTab === o.position;
      });
      this.buttons[this.selectedButtonIndex].type = this.types[index].name;
    },
    getKeyIndex(object, key) {
      return Object.keys(object).indexOf(key);
    },
    removeItem(item) {
      let index =
        this.buttons[this.selectedButtonIndex].alternatives.indexOf(item);
      this.buttons[this.selectedButtonIndex].alternatives.splice(index, 1);
    },
  },
  computed: {
    selectedBlock() {
      return this.$store.state.blocksBuild.selectedBlock;
    },
    autocompVModelPhone: {
      get() {
        return this.buttons[this.selectedButtonIndex].phone;
      },
      set(val) {
        this.this.buttons[this.selectedButtonIndex].phone = val;
      },
    },
  },
  watch: {
    selectedButtonIndex() {
      this.buttons[this.selectedButtonIndex].block_id = parseInt(
        this.buttons[this.selectedButtonIndex].block_id,
      );
      this.getActiveTab();
    },
    selectedBlock() {
      this.selectedButtonIndex = 0;
    },
    buttons: {
      deep: true,
      immediate: true,
      handler(val) {
        setTimeout(() => {
          if (this.$refs.form) this.$refs.form.validate();
          const errorsBagRef =
            this.$refs.form && this.$refs.form.errorBag
              ? this.$refs.form.errorBag
              : {};
          const errorsCount = Object.keys(
            this.$_.pickBy(errorsBagRef, (v, k) => {
              let keyIndex = this.getKeyIndex(errorsBagRef, k);
              if (
                keyIndex < this.buttonsListInputsPreset ||
                keyIndex === this.buttonsListInputsPreset - 1 + this.activeTab
              ) {
                return v;
              }
              return false;
            }),
          ).length;
          this.errorsCount = errorsCount;
          this.$emit("input", { errorsCount });
        }, 200);
      },
    },
  },
};
</script>

<style></style>
